export default __webpack_public_path__ + "images/c014961b24f749b665eef0738eea39f2.png";